/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import style from './CorrectnessLegendSVG.scss';

const CorrectnessLegendSVG = ({ correct, incorrect, className = null }) => {
  return (
    <span className={style.correctnessLegend}>
      <svg
        className={cx(className, {
          [style.correct]: correct,
          [style.incorrect]: incorrect,
        })}
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 6L12 0V12H0L6 6Z" fill="none" />
      </svg>
    </span>
  );
};

export default CorrectnessLegendSVG;
